import { Link } from "react-router";
import styles from './Navbar.module.css'
import { LeaguesNavItem, LanNavItem, MoreNavItem } from "./DropdownNavItems";
import { GamesNavItem, TournamentNavItem} from "./SingleNavItems";
import { AccountNavItem } from "./AccountNavItem";
import { useState } from "react";
import navbarLogo from 'assets/images/misc/usync-navbar-logo_9.6.26.webp';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    }

    const closeMenu = () => {
        setMenuOpen(false);
        setActiveDropdown(null);
    }

    const handleDropdownToggle = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    }

    return (
        <header className={styles.header}>
            <button className={styles.hamburger} onClick={toggleMenu} />
            <div className={styles.headerLeft}>
                <Link to="/" onClick={closeMenu}>
                    <img src={navbarLogo} alt="uSync Logo" />
                </Link>
            </div>

            

            <nav className={`${styles.headerMiddle} ${menuOpen ? styles.menuOpen : ''}`}>
                <div className={styles.menu}>
                    <Link to="/" className={styles.navLink} onClick={closeMenu}>
                        Home
                    </Link>
                    
                    <GamesNavItem closeMenu={closeMenu}/>
                    <LeaguesNavItem 
                        closeMenu={closeMenu} 
                        isOpen={activeDropdown === 'leagues'} 
                        onToggle = {() => handleDropdownToggle('leagues')} 
                    />

                    <LanNavItem 
                        closeMenu={closeMenu} 
                        isOpen={activeDropdown === 'lans'} 
                        onToggle = {() => handleDropdownToggle('lans')} 
                    />

                    <TournamentNavItem closeMenu={closeMenu}/>
                    <MoreNavItem 
                        closeMenu={closeMenu} 
                        isOpen={activeDropdown === 'more'} 
                        onToggle = {() => handleDropdownToggle('more')}
                    />

                    <AccountNavItem closeMenu={closeMenu} variant="menu" />
                </div>
            </nav>

            <div className={`${styles.headerRight} ${menuOpen ? styles.menuOpen : ''}`}>
                <AccountNavItem closeMenu={closeMenu} />
            </div>
        </header>
    )
}

export default Navbar;
